import React from 'react';

import { IdContext, getUniqueId } from './withIdContext';

const withId = (componentName, uniqueNameProperty = ['id', 'name']) => (WrappedComponent) => {
  const IdWrapper = (props) => {
    const id = getUniqueId(props, uniqueNameProperty);

    return (
      <IdContext.Consumer>
        { (prefix) => {
          let componentId;
          if (!id) {
            componentId = componentName;
          } else {
            componentId = [componentName, id].join('_');
          }

          const uniqueId = prefix ? `${prefix}_${componentId}` : componentId;

          return (
            <WrappedComponent {...props} id={uniqueId} data-id={uniqueId} />
          );
        }}
      </IdContext.Consumer>
    );
  };

  // copy own props to wrapped component (eg, propTypes, defaultProps, Row, Option, ...)
  Object.keys(WrappedComponent).forEach((attribute) => {
    if (Object.prototype.hasOwnProperty.call(WrappedComponent, attribute)) {
      IdWrapper[attribute] = WrappedComponent[attribute];
    }
  });

  return IdWrapper;
};

export default withId;
